import React from "react";
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
// Material UI
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// Custom Components
import { ImageAttribution } from "../components/ImageAttribution";
import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import SubComponentCard from "../components/SubComponent";
import MCInstructions from "../components/MCInstructions";

export default function ModuleSummary(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  const noFeedbackInstructions = (ins, type) => {

    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-0");
      }
      case "1": {
        return pickInstructions("variation-4");
      }
      case "2": {
        return pickInstructions("variation-8");
      }
    }
  };

  const lowFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-1-");
      }
      case "1": {
        return pickInstructions("variation-5");
      }
      case "2": {
        return pickInstructions("variation-9");
      }
    }
  };

  const midFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-2");
      }
      case "1": {
        return pickInstructions("variation-6");
      }
      case "2": {
        return pickInstructions("variation-10");
      }
    }
  };

  const highFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-3");
      }
      case "1": {
        return pickInstructions("variation-7");
      }
      case "2": {
        return pickInstructions("variation-11");
      }
    }
  };

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>
      <Instructions
        ins={ins.filter((data) => data.label.includes(`-default`))}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <ComponentCard
        title="Objective"
        id={data.core.id}
        commentsCount={componentCommentsCount(data.core.id)}
      >
        {/* <ComponentPreview>
          <ObjectiveItem objective={objective} index={index} diagram />
        </ComponentPreview> */}
        <ComponentStepLabel number="1" title="Image:" />
        <ImageAttribution attribution={data.core.media} tl={tl} dir={dir} />

        <ComponentStepLabel number="2" title="Objective:" />
        <SubComponentCard
          title="Objective"
          id={data.core.id + "objective"}
          commentsCount={componentCommentsCount(data.core.id + "objective")}
        >
          <Paper elevation={0} square className="p-16">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Text (TL):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.core.text_tl}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Text (EN):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.core.text_en}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>
      </ComponentCard>

      {data.item_feedback.map((feedback, index) => (
        <ComponentCard
          key={feedback.id}
          title={feedback.title_en}
          id={feedback.id}
          commentsCount={componentCommentsCount(feedback.id)}
        >
          <SubComponentCard
            title="No Attempt"
            id={feedback.id + "nf"}
            commentsCount={componentCommentsCount(feedback.id + "nf")}
          >
            <MCInstructions
              ins={noFeedbackInstructions(ins, feedback.interaction_type)}
              course={course}
              dir={dir}
              tl={tl}
              componentCommentsCount={componentCommentsCount}
            />
          </SubComponentCard>

          <SubComponentCard
            title="Low Feedback"
            id={feedback.id + "lf"}
            commentsCount={componentCommentsCount(feedback.id + "lf")}
          >
            <MCInstructions
              ins={lowFeedbackInstructions(ins, feedback.interaction_type)}
              course={course}
              dir={dir}
              tl={tl}
              componentCommentsCount={componentCommentsCount}
            />
          </SubComponentCard>

          <SubComponentCard
            title="Mid Feedback"
            id={feedback.id + "mf"}
            commentsCount={componentCommentsCount(feedback.id + "mf")}
          >
            <MCInstructions
              ins={midFeedbackInstructions(ins, feedback.interaction_type)}
              course={course}
              dir={dir}
              tl={tl}
              componentCommentsCount={componentCommentsCount}
            />
          </SubComponentCard>

          <SubComponentCard
            title="High Feedback"
            id={feedback.id + "hf"}
            commentsCount={componentCommentsCount(feedback.id + "hf")}
          >
            <MCInstructions
              ins={highFeedbackInstructions(ins, feedback.interaction_type)}
              course={course}
              dir={dir}
              tl={tl}
              componentCommentsCount={componentCommentsCount}
            />
          </SubComponentCard>
        </ComponentCard>
      ))}
    </div>
  );
}
